/* eslint-disable import/prefer-default-export */

export const allAudiences = ['Young Learners', 'Teens', 'Adults']
